
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiNotunderway as ObiNotunderwayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-notunderway.js';
 
 
 

 
 export const ObiNotunderway = createComponent({
   react: React,
   tagName: 'obi-notunderway',
   elementClass: ObiNotunderwayElement,
   events: {
     
   }
  });
 
 